import React, { useEffect } from 'react'
import { AlignmentResultsChartHook } from '../hooks/ChartHooks'
import { isNullOrUndefined } from '../utils/generalFunctions'
import * as con from "../Constants"
import AlignmentResultDetail from '../components/AlignmentResultDetail'
import ResultQueryDropdown from '../components/ResultQueryDropdown'
import { RefSelectedAlignmentResults } from '../hooks/AnnotationResultsHook'
import { Col, Row, Typography, Tooltip } from 'antd'
import { RefLanguage } from '../hooks/LanguageHooks'
import { BackButton } from '../elements/CustomButtons'
import { InfoCircleOutlined } from '@ant-design/icons'

const { Title } = Typography

function AlignmentResultsPage() {

    // Translation
    const i18n = RefLanguage()

    // Chart Hook
    const [plotRef, chart] = AlignmentResultsChartHook({ i18n })

    // Results Data
    const selectedResults = RefSelectedAlignmentResults()

    useEffect(() => {

        if (!chart.initialized)
            chart.initialize()

        if (!isNullOrUndefined(selectedResults)) {
            chart.update(selectedResults)
        }

    }, [chart, selectedResults])

    return (
        <div style={{ width: "100%", padding: "0 2vh" }}>
            <Row style={{ marginTop: "0.3vh", marginBottom: "2vh" }} align="middle">
                <Col span={2}>
                    <div data-tour="back-button">
                        <BackButton specificPage={con.PAGE_ANNOTATION_RESULTS} />
                    </div>
                </Col>
                <Col span={20}>
                    <Title level={3} style={{
                        marginTop: "0.3vh",
                        paddingTop: 0,
                        textAlign: 'center',
                        marginBottom: 0
                    }}>
                        {i18n.t("alignmentResults")}
                    </Title>
                </Col>
                <Col span={2} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingRight: '50px' }}>
                    <Tooltip 
                        title={<div dangerouslySetInnerHTML={{ __html: i18n.t("chartVisualizationHelp") }} />}
                        placement="bottomLeft"
                    >
                        <InfoCircleOutlined 
                            style={{ 
                                fontSize: "24px", 
                                color: "#1890ff", 
                                cursor: "help" 
                            }} 
                        />
                    </Tooltip>
                </Col>
            </Row>

            <div style={{ marginBottom: "2vh" }}>
                <ResultQueryDropdown />
            </div>

            <div
                data-tour="results-chart"
                style={{
                    marginBottom: "3vh",
                    minHeight: "300px",
                    padding: "1vh",
                    backgroundColor: "white",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
            >
                <svg
                    ref={plotRef}
                    style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "280px"
                    }}
                />
            </div>

            <div
                data-tour="alignment-detail"
                style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "2vh",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    minHeight: "200px"
                }}
            >
                <AlignmentResultDetail />
            </div>
        </div>
    )
}

export default AlignmentResultsPage
